import { ENDPOINT } from '@/shared/constants'
import { AXIOSAPI } from '@sdgsystems/vue-common/components/requests-common'

const state = {
  settings: {}
}

const getters = {
  siteSettings: state => state.settings
}

const mutations = {
  setSettings (state, settings) {
    state.settings = settings
  }
}

const actions = {
  async getSiteSettings (context) {
    try {
      const res = await AXIOSAPI.get(ENDPOINT + 'orgsettings')
      context.commit('setSettings', res.data)
    } catch (e) {
      console.log(e)
    }
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/settings.js